import React, { useEffect, useState } from 'react';
import {
	useNavigate, useLocation, Outlet,
} from 'react-router-dom';

import Breadcrumb from '../../component-library/breadcrumb';

const Profile = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const [navItem, setNavItem] = useState('about');
	const [breadcrumbData, setBreadcrumbData] = useState([
		{ name: 'Home', url: '/' },
		{ name: 'Catalog', url: '/catalog' },
		{ name: 'Details' },
	]);

	useEffect(() => {
		const newActiveSection = 'details';
		const newBreadcrumbData = [
			{ name: 'Home', url: '/' },
			{ name: 'My Profile' },
		];
		setBreadcrumbData(newBreadcrumbData);
		setNavItem(newActiveSection);
	}, [pathname]);

	return (
		<>
			<Breadcrumb
				data={breadcrumbData}
			/>
			<div className="details__grid">
				<div className="left-navigation">
					<button
						className={`${navItem === 'details' && 'is-active'}`}
						onClick={() => navigate('/profile')}
						type="button"
					>
						Details
					</button>
				</div>
				<div>
					<h2>My Profile</h2>
					<Outlet />
				</div>
			</div>
		</>
	);
};

export default Profile;
